/**
 * TextLink — the router-coupled "View all ›": the shared `TextAnchor` (`@argus/ui`,
 * packages/ui/src/text-button.tsx) wrapped in TanStack's `createLink` for a type-safe `to`.
 * `TextButton` (the in-place `<button>` twin) is re-exported from the package so the
 * existing `../ui/text-link.tsx` imports keep working.
 */
import { TextAnchor } from '@argus/ui';
import { createLink, type LinkComponent } from '@tanstack/react-router';

export { TextButton } from '@argus/ui';

const CreatedTextLink = createLink(TextAnchor);

/** "View all ›" as a type-safe router link. */
export const TextLink: LinkComponent<typeof TextAnchor> = (props) => <CreatedTextLink {...props} />;
